import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ApiService } from './api-service';

@Injectable({
  providedIn: 'root',
})

export class AddressService {
  constructor(private http: HttpClient, private api: ApiService) {}

  getRegions() {
    // const url = `https://api.staging.buildpass.baguio.gov.ph/api/regions?search_term=${query}`;
    const url = `/GetRegions`;
    return this.api.get(url).pipe(
      map((data: any) => {
        // Assuming data is an array of regions
        const regions = data as any[];
  
        regions.sort((a, b) => {
          if (a.name === 'CAR') {
            return -1; 
          } else if (b.name === 'CAR') {
            return 1; 
          } else {
            return a.name.localeCompare(b.name); 
          }
        });
  
        return regions;
      }),
      catchError((error) => {
        return throwError('Something went wrong');
      })
    );
  }
  

  getProvinces(regionId) {
    // const url = `https://api.staging.buildpass.baguio.gov.ph/api/provinces?search_term=${query}&region_id=${regionId}`;
    const url = `/GetProvinces?regionId=${regionId}`;
    return this.api.get(url).pipe(
      map((data:any) => {
        return data;
      })
    )
  }

  getMunicipalitiesCities(provinceId) {
    // const url = `https://api.staging.buildpass.baguio.gov.ph/api/cities?province_id=${provinceId}`;    
    const url = `/GetCities?provinceId=${provinceId}`;    
    return this.api.get(url).pipe(
     map((data:any) => {
      return data;
     }) 
    )
  }

  getAllMunicipalitiesCities() {
    const url = '/GetCities'
    return this.api.get(url).pipe(
      map((data:any) => {
       return data;
      }) 
     )
  }

  getBarangaysBaguio(): Observable<any[]> {
    return this.http.get<any>(
     'https://api.staging.buildpass.baguio.gov.ph/api/barangays'
    );
  }

}

